import $ from '@vaersaagod/tools/Dom';

export default el => {
    const dates = $(el).find('[data-item]');

    let datesIndex = 0;
    let datesInterval = 0;

    const rotateDates = () => {
        const current = dates.get(datesIndex);
        TweenLite.to(current, 0.65, { y: '-120%', ease: Cubic.easeInOut });

        datesIndex = (datesIndex < dates.length - 1) ? datesIndex + 1 : 0;

        const next = dates.get(datesIndex);
        TweenLite.set(next, { y: '120%' });
        TweenLite.to(next, 0.65, { y: '0%', ease: Cubic.easeInOut });
    };

    const init = () => {
        datesInterval = setInterval(rotateDates, 5000);
        dates.each((node, index) => {
            if (index !== 0) {
                TweenLite.set(node, { y: '120%', display: 'block' });
            }
        });
    };

    const destroy = () => {
        clearInterval(datesInterval);
    };

    return {
        init,
        destroy
    };
};



// WEBPACK FOOTER //
// ./src/js/components/DateRotator.js